export const CONTENT_GROUPS = [
  {
    group: "Brand",
    fields: [
      { key: "site_name", label: "Site name", type: "text" },
      { key: "tagline", label: "Tagline", type: "text" },
      { key: "logo_image", label: "Logo", type: "image" },
    ],
  },
  {
    group: "Home — Hero",
    fields: [
      { key: "hero_title", label: "Hero title", type: "text" },
      { key: "hero_subtitle", label: "Hero subtitle", type: "text" },
      { key: "hero_image", label: "Hero background image", type: "image" },
    ],
  },
  {
    group: "Home — Welcome",
    fields: [
      { key: "welcome_heading", label: "Welcome heading", type: "text" },
      { key: "welcome_body", label: "Welcome text", type: "textarea" },
    ],
  },
  {
    group: "Home — Highlights",
    fields: [
      { key: "highlight_community_title", label: "Community title", type: "text" },
      { key: "highlight_community_body", label: "Community text", type: "textarea" },
      { key: "highlight_community_image", label: "Community image", type: "image" },
      { key: "highlight_participation_title", label: "Participation title", type: "text" },
      { key: "highlight_participation_body", label: "Participation text", type: "textarea" },
      { key: "highlight_participation_image", label: "Participation image", type: "image" },
      { key: "highlight_pathways_title", label: "Pathways title", type: "text" },
      { key: "highlight_pathways_body", label: "Pathways text", type: "textarea" },
      { key: "highlight_pathways_image", label: "Pathways image", type: "image" },
    ],
  },
  {
    group: "Home — Region",
    fields: [
      { key: "region_heading", label: "Region heading", type: "text" },
      { key: "region_body", label: "Region text", type: "textarea" },
      { key: "region_image", label: "Region image", type: "image" },
    ],
  },
  {
    group: "About",
    fields: [
      { key: "about_hero_heading", label: "About heading", type: "text" },
      { key: "about_hero_sub", label: "About subtitle", type: "text" },
      { key: "about_image", label: "About image", type: "image" },
      { key: "purpose_body", label: "Purpose", type: "textarea" },
      { key: "story_1_title", label: "Story 1 title", type: "text" },
      { key: "story_1_body", label: "Story 1 text", type: "textarea" },
      { key: "story_2_title", label: "Story 2 title", type: "text" },
      { key: "story_2_body", label: "Story 2 text", type: "textarea" },
      { key: "story_3_title", label: "Story 3 title", type: "text" },
      { key: "story_3_body", label: "Story 3 text", type: "textarea" },
      { key: "governance_body", label: "Governance", type: "textarea" },
      { key: "board_body", label: "Board & leadership", type: "textarea" },
      { key: "pikorua_body", label: "Pikorua symbolism", type: "textarea" },
    ],
  },
  {
    group: "Membership",
    fields: [
      { key: "membership_hero_heading", label: "Membership heading", type: "text" },
      { key: "membership_hero_sub", label: "Membership subtitle", type: "text" },
      { key: "membership_image", label: "Membership image", type: "image" },
      { key: "membership_intro", label: "Intro text", type: "textarea" },
      { key: "affiliation_heading", label: "Affiliation heading", type: "text" },
      { key: "affiliation_body", label: "Affiliation text", type: "textarea" },
    ],
  },
  {
    group: "Partner / Sponsor",
    fields: [
      { key: "partner_name", label: "Partner name", type: "text" },
      { key: "partner_url", label: "Partner website URL", type: "text" },
      { key: "partner_blurb", label: "Partner blurb", type: "textarea" },
      { key: "partner_logo", label: "Partner logo (leave empty to use the yellow Ray White badge)", type: "image" },
    ],
  },
  {
    group: "Social & Links",
    fields: [
      { key: "facebook_url", label: "Facebook page URL", type: "text" },
    ],
  },
  {
    group: "Contact",
    fields: [
      { key: "contact_person", label: "Contact person", type: "text" },
      { key: "contact_email", label: "Email", type: "text" },
      { key: "contact_phone", label: "Phone", type: "text" },
      { key: "contact_postal", label: "Postal address", type: "text" },
      { key: "contact_note", label: "Location note", type: "text" },
    ],
  },
];
